import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class LoginServicesService {
  url = environment.apiUrl;
  urlMovil = environment.xigaMovil;

  private password: { [key: string]: any } = {};

  constructor(private http: HttpClient) {

  }


  checkStatus(): Observable<any> {
    return this.http.get(this.url + 'status');
  }

  /*
  public int ClientNumber {get;set;}
        public string  User {get;set;} = string.Empty;
        public decimal Lat {get;set;}
        public decimal Lon {get;set;}
        public string ? Ip {get;set;}  = null;
        public string? DeviceType {get;set;} = null;

  */
  login(clientNumber: number, pswd: string): Observable<any> {
    return this.http.post(this.url + 'login', {
      ClientNumber: clientNumber,
      password: pswd
    });
  }

  saveLoginLocation(clientNumber: number, username: string,latitude:number,longitude:number): Observable<any> {
    return this.http.post(this.url + 'login/save', {
      ClientNumber: clientNumber,
      User: username,
      Lat:latitude,
      Lon:longitude,
    });
  }

  loginMovil(clientNumber: number, pswd: string, firstTime: boolean, version: string): Observable<any> {
    return this.http.post(this.urlMovil + 'api/general/auth', {
      user: clientNumber,
      password: pswd,
      firstTime: firstTime,
      version: version
    });
  }

  validateOTPMovil(clientNumber: number, code: string ): Observable<any> {
    return this.http.get(this.urlMovil + 'validate/otp?code='+code+'&clientNumber='+clientNumber);
  }


  refreshToken(): Observable<any> {
    return this.http.post(this.url + 'login/refresh', {});
  }

  isValidToken(): boolean {
    const localToken = sessionStorage.getItem("authCode");
    if (localToken) {
      const decoded = jwtDecode(localToken!);

      return (Math.floor((new Date).getTime() / 1000)) < decoded.exp!;
    } else {
      return false;
    }
  }
  setData(key: string, value: any) {
    this.password[key] = value;
  }

  getData(key: string) {
    return this.password[key];
  }

  recoveryPhone(clientNumber: number) {
    return this.http.get(this.url + 'user/recoveryPhone?clientNumber=' + clientNumber);
  }

  validatePhoneNumber(clientNumber: number, phoneNumber: string,isRecovery:boolean,dialCode:string): Observable<any> {
    let data = {
      phoneNumber: phoneNumber,
      clientNumber: clientNumber, 
      type:isRecovery?1:2
      ,dialCode: dialCode
    }
    return this.http.post(this.url + 'login/validate/phone', data);
  }



  saveLoginLog(clientNumber: number, user: string, latitude: number, longitude: number) {
    let data = {
      clientNumber: clientNumber,
      user: user,
      latitude: latitude,
      longitude: longitude,
    }
    return this.http.post(this.url + 'login/save', data);
  }

  generatePasswordRequest(clientNumber: number,code:string) {
    let data = {
      clientNumber: clientNumber,
      code:code
    }
    return this.http.post(this.url + 'login/password/recovery/request', data);
  }

  saveNewPassword(clientNumber:number,password:string,token:string,oldPassword:string="",isRecovery:boolean){
    let data = {
      clientNumber: clientNumber,
      password: password,
      token:token,
      oldPassword:oldPassword,
      isRecovery:isRecovery
    }
    return this.http.post(this.url + 'login/recovery/password', data);
  }
  validateExpiration(clientNumber:number){

    return this.http.get(this.url + 'login/expired/status?clientNumber='+clientNumber);
  }

  login2FA(clientNumber: string, pswd: string,code:string): Observable<any> {
    return this.http.post(this.url + 'login/auth/validate', {
      ClientNumber: clientNumber,
      password: pswd,
      code:code
    });
  }

}


